document.addEventListener("DOMContentLoaded", function () {
  if (!customElements.get("index-reviews")) {
    customElements.define(
      "index-reviews",
      class IndexReviews extends HTMLElement {
        constructor() {
          super();
          this.is_show_diff_type = $(this).attr("data-is-diff-type");
          this.isShowOppo = $(this).attr("data-is-show-oppo");
          this.isAutoplay = $(this).attr("data-is-autoplay");
          this.el = this.querySelector('.index-reviews-swiper');
          this.swiper_button_next = this.querySelector('.swiper-button-next');
          this.swiper_button_prev = this.querySelector('.swiper-button-prev');
          this.swiper_pagination = this.querySelector('.swiper-pagination');
          this.initIndexReviews();

          console.log(this.isShowOppo);
        }

        initIndexReviews() {
          const that = this;
          let swiperOpts = {
            autoHeight:true,
            'loop': true, // 循环模式选项
            'slidesPerView': 1,
            'spaceBetween': 15,
            'centeredSlides': true,
            'initialSlide': that.isShowOppo == "true" ? 1 : 0,
            'centeredSlidesBounds': true,
            // 如果需要前进后退按钮
            // 如果需要分页器
            'pagination': {
              'el': that.swiper_pagination,
            },
            'breakpoints': {
              590: {
                'slidesPerView': 3,
                'spaceBetween': that.isShowOppo == "true" ? 5 : 20,
                'centeredSlides': true,
                'initialSlide': that.isShowOppo == "true" ? 1 : 0,
              }
            }
          }

          if(that.isAutoplay){
            swiperOpts.autoplay = {
              disableOnInteraction: false,
            }
          }
          new Swiper(that.el, swiperOpts);
        }
      }
    );
  }
});
